import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import EdgeEndStar from '../../geomgraph/EdgeEndStar';
import EdgeEndBundle from './EdgeEndBundle';
var EdgeEndBundleStar = /*#__PURE__*/function (_EdgeEndStar) {
  _inherits(EdgeEndBundleStar, _EdgeEndStar);
  function EdgeEndBundleStar() {
    _classCallCheck(this, EdgeEndBundleStar);
    return _possibleConstructorReturn(this, _getPrototypeOf(EdgeEndBundleStar).call(this));
  }
  _createClass(EdgeEndBundleStar, [{
    key: "updateIM",
    value: function updateIM(im) {
      for (var it = this.iterator(); it.hasNext();) {
        var esb = it.next();
        esb.updateIM(im);
      }
    }
  }, {
    key: "insert",
    value: function insert(e) {
      var eb = this._edgeMap.get(e);
      if (eb === null) {
        eb = new EdgeEndBundle(e);
        this.insertEdgeEnd(e, eb);
      } else {
        eb.insert(e);
      }
    }
  }]);
  return EdgeEndBundleStar;
}(EdgeEndStar);
export { EdgeEndBundleStar as default };